import { Injectable, EnvironmentInjector, createComponent } from '@angular/core';
import { MarkerCluster } from 'leaflet';

import { MapCardComponent } from '@finder/shared/components/map-card/map-card.component';
import { MapDataLocationCard, MapDataLocationMarker } from '@finder/shared/components/map/map/map.interface';
import { OperatingStatusComponent } from '@finder/shared/components/operating-status/operating-status.component';

@Injectable({
    providedIn: 'root'
})
export class MapCardService {
    constructor(
        private injector: EnvironmentInjector,
    ) {}

    getCard(finderMarker: MapDataLocationMarker) {
        // Create card component to pass to map (for popup)
        const component = createComponent(MapCardComponent, {environmentInjector: this.injector});

        // Set the card data
        component.instance.marker = finderMarker;

        // Manually trigger change detection so data gets applied
        component.changeDetectorRef.detectChanges();

        return component.location.nativeElement;
    }

    getClusterMarker(cluster: MarkerCluster) {
        const childCount = cluster.getChildCount();

        return `
            <div class="marker-numbered" aria-label="${childCount}">
                ${childCount}
            </div>
        `;
    }

    getWaitTime(finderMapCard: MapDataLocationCard) {
        const component = createComponent(OperatingStatusComponent, {environmentInjector: this.injector});

        // Set the data
        component.instance.data = finderMapCard;
        component.instance.labels = finderMapCard.waitTimeLabels;
        component.instance.facilityId = finderMapCard.id;
        component.instance.usedAsPin = true;

        // trigger change detection
        component.changeDetectorRef.detectChanges();

        // return the html
        return component.location.nativeElement;
    }
}
